module.exports = __webpack_public_path__ + "img/microphone_cropped_transparent.26cada99.png";